import { FetcherWithComponents, useFetcher } from "@remix-run/react";
import { SerializeFrom } from "@remix-run/server-runtime";

export type TypedFetcherStates<TData = any> = Omit<
  FetcherWithComponents<TData>,
  "type"
> & {
  isInit: boolean;
  isDone: boolean;
  isIdle: boolean;
  isActionReload: boolean;
  isActionSubmission: boolean;
  isActionRedirect: boolean;
  isNormalLoad: boolean;
  data: TData | null;
};

export function useTypedStateFetcher<TData = any>(): TypedFetcherStates<
  SerializeFrom<TData>
> {
  const fetcher = useFetcher<TData>();
  const { state, data, formMethod } = fetcher;

  const isInit = state === "idle" && data === null;
  const isDone = state === "idle" && data !== null;
  const isActionReload = state === "loading" && formMethod && data !== null;
  const isActionSubmission = state === "submitting";
  const isActionRedirect =
    state === "loading" && formMethod === null && data === null;
  const isNormalLoad = state === "loading" && formMethod === null;

  return {
    isInit,
    isDone,
    isIdle: isInit || isDone,
    isActionReload,
    isActionSubmission,
    isActionRedirect,
    isNormalLoad,
    data,
    // This raises a harmless warning in development: `fetcher.type` will be removed in v2
    // It's exactly why this component exists, to not access fetcher.type anymore in Remix v2.
    ...fetcher,
  };
}
